import { UserCreatedContext } from '@choco-admin/types';

import { UserCreatedContext as GqlUserCreatedContext } from '../generated';

/**
 * Bridge between the domain `UserCreatedContext` enum and the generated GraphQL
 * one (codegen runs with `enumsAsConst`, so `UserCreatedContext` is both a const
 * object and the union of its values). The string values are identical, so this
 * is an exhaustive literal map — no casts.
 *
 * The parameter carries `'%future added value'` because the generated field does:
 * `createdContext` is typed `Maybe<UserCreatedContext | '%future added value'>`,
 * so a schema that gains a member the portal has not been rebuilt against still
 * type-checks here and falls through to `undefined`. Under `enumsAsTypes` the
 * enum type carried that member itself, which is why the parameter did not need
 * to name it before.
 */
export const gqlUserCreatedContextToUserCreatedContext = (
  createdContext?: GqlUserCreatedContext | '%future added value' | null
): UserCreatedContext | undefined => {
  switch (createdContext) {
    case 'addSalesRep':
      return UserCreatedContext.ADD_SALES_REP;
    case 'buyerConcierge':
      return UserCreatedContext.BUYER_CONCIERGE;
    case 'buyerInviteTeam':
      return UserCreatedContext.BUYER_INVITE_TEAM;
    case 'customerMassAccountCreator':
      return UserCreatedContext.CUSTOMER_MASS_ACCOUNT_CREATOR;
    case 'federated':
      return UserCreatedContext.FEDERATED;
    case 'organicSignUp':
      return UserCreatedContext.ORGANIC_SIGN_UP;
    case 'supplierInviteTeam':
      return UserCreatedContext.SUPPLIER_INVITE_TEAM;
    case 'supplierInvitesBuyer':
      return UserCreatedContext.SUPPLIER_INVITES_BUYER;
    case 'userCreatedFromAdmin':
      return UserCreatedContext.USER_CREATED_FROM_ADMIN;
    default:
      return undefined;
  }
};
